"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSaveChatSuscriptionsRxjs = exports.createSuscriptions = void 0;
var chat_1 = require("./chat");
var events = require("./events");
var survey_1 = require("./survey");
var utils_1 = require("../utils");
var rxjs_1 = require("rxjs");
var models_1 = require("../models");
var _1 = require(".");
function initializeChatConfiguration(event) {
    (0, chat_1.initializeFive9Configuration)(event.detail);
}
function saveFive9Survey(event) {
    (0, survey_1.saveSurvey)(event.detail);
    event.stopPropagation();
}
function five9SurveyLoading(event) {
    (0, survey_1.surveyLoading)(event.detail);
}
function saveFive9Chat(event) {
    if ((0, utils_1.getSessionProperty)(utils_1.SESSION_PROPERTIES.status) != ChatModel.Steps.Finished)
        (0, chat_1.setChatSession)(event.detail);
}
function createSuscriptions() {
    exports.five9SaveChatSuscribe$ = new rxjs_1.Subject();
    createSaveChatSuscriptionsRxjs();
    window.addEventListener(events.OPEN_FIVE9_CHAT_EVENT, function () { return (0, chat_1.open)(); });
    window.addEventListener(events.CLOSE_FIVE9_CHAT_EVENT, function () {
        Five9SocialWidget.removeWidget();
        events.removeChatEvent(events.MINIMIZE_FIVE9_CHAT_EVENT, chat_1.minimizeChatFive9);
        events.removeChatEvent(events.MAXIMIZE_FIVE9_CHAT_EVENT, chat_1.maximizeChatFive9);
    });
    window.addEventListener(events.SEND_SURVEY_FIVE9_CHAT_EVENT, saveFive9Survey);
    window.addEventListener(events.SURVEY_LOADING_FIVE9_CHAT_EVENT, five9SurveyLoading);
    window.addEventListener(events.HIDDE_THANKS_RESPONSE_FIVE9_CHAT_EVENT, survey_1.hiddeThanksReponse);
    window.addEventListener(events.HIDDE_THANKS_RESPONSE_FIVE9_CHAT_FIVE9_CHAT_EVENT, survey_1.hideConversationHistory);
    window.addEventListener(events.SAVE_FIVE9_CHAT_EVENT, saveFive9Chat);
    window.addEventListener(events.OPEN_SURVEY_FIVE9_CHAT_EVENT, survey_1.replaceSurvey);
    window.addEventListener("message", function (event) {
        try {
            var data = JSON.parse(event.data);
            if (data.value)
                data = data.value;
            if (data.step && data.step == ChatModel.Steps.Finished) {
                events.dispatchChatEvent(events.SAVE_FIVE9_CHAT_EVENT, data);
                events.dispatchChatEvent(events.OPEN_SURVEY_FIVE9_CHAT_EVENT);
            }
            else if (data.step && data.step == ChatModel.Steps.Conversation) {
                (0, chat_1.setNewStatus)(data.step);
            }
        }
        catch (error) { }
    });
    window.addEventListener(events.INITIALIZE_CONFIGURATION_FIVE9_CHAT_EVENT, initializeChatConfiguration);
    window.addEventListener(events.MAXIMIZE_FIVE9_CHAT_EVENT, chat_1.maximizeChatFive9);
    window.addEventListener(events.MINIMIZE_FIVE9_CHAT_EVENT, chat_1.minimizeChatFive9);
}
exports.createSuscriptions = createSuscriptions;
function createSaveChatSuscriptionsRxjs() {
    exports.five9SaveChatSuscribe$
        .pipe((0, rxjs_1.tap)(function () { return (0, _1.surveyLoadingEvent)(true); }), (0, rxjs_1.switchMap)(function (response) { return (0, models_1.postSurvey)(response); }), (0, rxjs_1.tap)(function () { return (0, _1.surveyLoadingEvent)(false); }))
        .subscribe({
        next: function () { return (0, _1.endOfSurveySuccesfull)(); },
    });
}
exports.createSaveChatSuscriptionsRxjs = createSaveChatSuscriptionsRxjs;
//# sourceMappingURL=suscriptions.js.map